import EventDetails1 from "./EventDetails1";

const events = {
    1: EventDetails1
};

export default events;